import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider, Table, Input, Tooltip, Space } from "antd";
import { SearchOutlined, CheckCircleOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";

export const UniformesPerfis = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [search, setSearch] = useState("");

  useEffect(() => {
    listarColaboradores();
  }, []);

  // LISTAR COLABORADORES
  const listarColaboradores = async () => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_perfis/listar_colaboradores`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Matrícula",
      dataIndex: "matricula",
      sorter: (a, b) => a.matricula?.toString()?.localeCompare(b.matricula?.toString()),
    },
    {
      title: "Colaborador",
      dataIndex: "nome",
      sorter: (a, b) => a.nome?.localeCompare(b.nome),
    },
    {
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Tooltip title="Filiais">
          <Button
            loading={loading}
            onClick={() => navigate(`/uniformes/perfis/filiais/${e.id}`)}
            icon={<CheckCircleOutlined />}
          />
        </Tooltip>
      ),
      dataIndex: "acoes",
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.nome?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.matricula?.toString()?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Uniformes" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Uniformes Perfis"
              subtitle="Liberação de Filiais para lançamento"
              icon={<UsergroupAddOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
              </Space>
              <Divider />
              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
